import { useEffect } from 'react';
import confetti from 'canvas-confetti';

/**
 * Fires a single "realistic" confetti burst on mount.
 *
 * Drop-in replacement for the previous `react-canvas-confetti` wrapper
 * that used `<Realistic autorun={{ speed: 1, duration: 1 }} />`. The old
 * wrapper fired one burst and then the short 1ms `duration` killed the
 * interval before it could repeat — this implementation mirrors that
 * behavior directly on top of `canvas-confetti`, saving ~240K in
 * node_modules and removing one React dependency.
 *
 * The burst is composed of the same 5 particle groups used by the
 * `realistic` preset conductor from react-canvas-confetti (total ~200
 * particles split across different spreads / velocities / scalars).
 */
function Confetti() {
  useEffect(() => {
    const total = 200;
    const origin = { y: 0.7 };

    confetti({
      spread: 26,
      startVelocity: 55,
      origin,
      particleCount: Math.floor(total * 0.25)
    });
    confetti({
      spread: 60,
      origin,
      particleCount: Math.floor(total * 0.2)
    });
    confetti({
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
      origin,
      particleCount: Math.floor(total * 0.35)
    });
    confetti({
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
      origin,
      particleCount: Math.floor(total * 0.1)
    });
    confetti({
      spread: 120,
      startVelocity: 45,
      origin,
      particleCount: Math.floor(total * 0.1)
    });
  }, []);

  // canvas-confetti injects its own canvas into the DOM (document.body)
  // and manages its own lifecycle, so this component renders nothing.
  return null;
}

export default Confetti;
